import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { updateCacheByType } from '../../../graphql/GraphQlProvider';
import { ResourceOption } from '../../../graphql/resources.datatypes';

interface DeleteResourceOptionVars {
    id: number;
}

interface DeleteResourceOptionData {
  deleteResourceOption: ResourceOption
}

export const DELETE_RESOURCE_OPTION_MUTATION = gql`
    mutation deleteResourceOption($id: Int!) {
        deleteResourceOption(id: $id) {
          id
        }
    }
`;

export const deleteResourceOption = () => useMutation<DeleteResourceOptionData, DeleteResourceOptionVars>(
  DELETE_RESOURCE_OPTION_MUTATION,
    {
        update: updateCacheByType('ResourceOption'),
    }
);

export default deleteResourceOption;